import { connect } from 'react-redux';
import SurveyTab from './SurveyTab';
import {
  addSurvey,
  getSurveyResult,
  getListSurveys,
  toggleActivationSurvey
} from '../../../store/actions/survey';

const mapStateToProps = ({
  surveyReducer,
  tabsReducer,
  userReducer
}) => ({
  surveyReducer,
  tabsReducer,
  userReducer
});
const mapDispatchToProps = {
  addSurvey,
  getSurveyResult,
  getListSurveys,
  toggleActivationSurvey
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SurveyTab);
